export default "__VITE_ASSET__BunWj7QA__"